// extracted by mini-css-extract-plugin
export default {"box":"index_box_irQLL","title":"index_title_Md7T9","list":"index_list_ZK7kj"};